export const PROCESS_ROUTE = 'events/PROCESS_ROUTE';

/**
 * @return {{type: string}}
 */
export const processRoute = () => ({ type: PROCESS_ROUTE });
